import { CSSProperties } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import styles from '../styles/CourseProgressLegend.module.css';
import { useTheme } from '@mui/material/styles';

type CourseProgressStatus = 'completed' | 'started' | 'not_started';
interface CourseProgressStatusItem {
  value: CourseProgressStatus;
  label: string;
}

export function CourseProgressLegend() {
  const legends: CourseProgressStatusItem[] = [
    { value: 'completed', label: 'Completed' },
    { value: 'started', label: 'Started' },
    { value: 'not_started', label: 'Not Started' }
  ];
  return (
    <Grid container spacing={2}>
      {legends.map((legend) => (
        <Grid key={legend.value}>
          <CourseProgressLegendItem status={legend} />
        </Grid>
      ))}
    </Grid>
  );
}

interface CourseProgressLegendItemProps {
  status: CourseProgressStatusItem;
}

function CourseProgressLegendItem(props: CourseProgressLegendItemProps) {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;

  function getStyle(status: CourseProgressStatus): CSSProperties {
    switch (status) {
      case 'completed':
        return { backgroundColor: primaryColor };
      case 'started':
        return { backgroundColor: primaryColor, opacity: '0.5' };
      default:
        return { backgroundColor: '#efefef' };
    }
  }

  return (
    <Grid container direction="column" justifyContent="center">
      <Grid>
        <div
          className={styles.legendBox}
          style={getStyle(props.status.value)}
        ></div>
      </Grid>
      <Grid>
        <div className={styles.legendLabel}>{props.status.label}</div>
      </Grid>
    </Grid>
  );
}
